import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, ActivityIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-white border-t border-bordercolor mt-auto" data-id="element-46">
      {/* HIPAA Compliance Strip */}
      <div className="bg-secondary py-4 px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-center" data-id="element-48">
          <ShieldCheckIcon className="w-5 h-5 text-primary flex-shrink-0" data-id="element-49" />
          <p className="text-sm font-medium text-brandtext" data-id="element-50">
            This website does not collect or store medical records. All medical
            information is handled through a secure, HIPAA-compliant telehealth
            system.
          </p>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-52">
          {/* Brand & Info */}
          <div className="space-y-4" data-id="element-53">
            <div className="flex items-center gap-2" data-id="element-54">
              <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center text-white" data-id="element-55">
                <ActivityIcon className="w-5 h-5" data-id="element-56" />
              </div>
              <span className="font-bold text-lg text-brandtext tracking-tight" data-id="element-57">
                [CLINIC NAME]
              </span>
            </div>
            <p className="text-sm text-brandtext-muted max-w-xs" data-id="element-58">
              Providing evidence-based, medically supervised testosterone
              replacement therapy via secure telehealth.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-59">
            <h3 className="text-sm font-semibold text-brandtext tracking-wider uppercase mb-4" data-id="element-60">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-61">
              <li data-id="element-62">
                <Link to="/" className="text-sm text-brandtext-muted hover:text-primary transition-colors" data-id="element-63">
                  Home
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/about" className="text-sm text-brandtext-muted hover:text-primary transition-colors" data-id="element-65">
                  About & Treatments
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/contact" className="text-sm text-brandtext-muted hover:text-primary transition-colors" data-id="element-67">
                  Contact & Scheduling
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-68">
            <h3 className="text-sm font-semibold text-brandtext tracking-wider uppercase mb-4" data-id="element-69">
              Contact
            </h3>
            <ul className="space-y-3 text-sm text-brandtext-muted" data-id="element-70">
              <li data-id="element-71">Phone: [PHONE]</li>
              <li data-id="element-72">Email: [EMAIL]</li>
              <li data-id="element-73">Serving patients in: [STATE]</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-bordercolor flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-74">
          <p className="text-sm text-brandtext-muted text-center md:text-left" data-id="element-75">
            &copy; {currentYear} [CLINIC NAME]. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-brandtext-muted" data-id="element-76">
            <span className="hover:text-primary cursor-pointer transition-colors" data-id="element-77">
              Privacy Policy
            </span>
            <span className="hover:text-primary cursor-pointer transition-colors" data-id="element-78">
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>;
}